/**
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-18 11:21:55
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-18 11:56:52
 * @FilePath: \hzs-nutra-wecom-shop\src\utils\api\closingBooks.js
 * @Description: 关账
 */

import req from "@/utils/axios.js";

export default {
    _bookingStatus: (params) => req.get("/wxShop/shop/closing/today", params),
    _booksList: (params) => req.get("/wxShop/shop/closing/list", params),
    _closeBook: (params) => req.post("/wxShop/shop/closing/close", params),
}